type BankLogo =
    | 'baac' | 'bay' | 'bbl' | 'boc' | 'bofa' | 'cimb'
    | 'citi' | 'gh' | 'gsb' | 'hsbc' | 'icbc' | 'kbank' | 'kk'
    | 'ktb' | 'lh' | 'peer2pay'
    | 'scb' | 'sc' | 'tbank' | 'ttb'
    | 'truewallet' | 'uobt';

/** =======================
 *  🚀 50 mock withdrawers
 *  =======================*/
export const withdrawTemplates: {
    name: string;
    phone: string;
    bank: BankLogo;
}[] = [
    { name: 'เกศินี', phone: '088-XXXX-985', bank: 'kbank' },
    { name: 'จิราพร', phone: '092-XXXX-541', bank: 'scb' },
    { name: 'ธีรพงษ์', phone: '092-XXXX-643', bank: 'ktb' },
    { name: 'กาญจนา', phone: '097-XXXX-527', bank: 'bbl' },
    { name: 'ประภาศรี', phone: '082-XXXX-975', bank: 'bay' },
    { name: 'เจษฎา', phone: '092-XXXX-329', bank: 'ttb' },
    { name: 'ชนากานต์', phone: '081-XXXX-214', bank: 'gsb' },
    { name: 'นงนภัส', phone: '084-XXXX-037', bank: 'kbank' },
    { name: 'พชร', phone: '063-XXXX-411', bank: 'kbank' },
    { name: 'สุภาวดี', phone: '091-XXXX-558', bank: 'scb' },

    { name: 'ณัชชา', phone: '095-XXXX-664', bank: 'sc' },
    { name: 'ศุภกร', phone: '086-XXXX-903', bank: 'scb' },
    { name: 'วรินทร์', phone: '083-XXXX-742', bank: 'lh' },
    { name: 'ธนวัฒน์', phone: '092-XXXX-271', bank: 'baac' },
    { name: 'ณัฐมน', phone: '094-XXXX-126', bank: 'icbc' },
    { name: 'จินตนา', phone: '087-XXXX-504', bank: 'kk' },
    { name: 'อรรถพล', phone: '068-XXXX-338', bank: 'peer2pay' },
    { name: 'พิมพ์ชนก', phone: '089-XXXX-417', bank: 'scb' },
    { name: 'ลลิตา', phone: '096-XXXX-780', bank: 'truewallet' },
    { name: 'ชัชวาล', phone: '093-XXXX-615', bank: 'citi' },

    { name: 'ศศิธร', phone: '082-XXXX-922', bank: 'scb' },
    { name: 'ธนพร', phone: '090-XXXX-847', bank: 'bofa' },
    { name: 'ณัฐพงษ์', phone: '066-XXXX-334', bank: 'boc' },
    { name: 'อนุชา', phone: '091-XXXX-279', bank: 'bay' },
    { name: 'หทัยรัตน์', phone: '088-XXXX-633', bank: 'kbank' },
    { name: 'พชรพล', phone: '089-XXXX-555', bank: 'scb' },
    { name: 'สุดารัตน์', phone: '093-XXXX-423', bank: 'ktb' },
    { name: 'ชยุต', phone: '084-XXXX-301', bank: 'bbl' },
    { name: 'ปิยาภรณ์', phone: '081-XXXX-997', bank: 'bay' },
    { name: 'เขมจิรา', phone: '095-XXXX-208', bank: 'ttb' },

    { name: 'ศิรา', phone: '097-XXXX-776', bank: 'gsb' },
    { name: 'ฐิติพร', phone: '083-XXXX-149', bank: 'kbank' },
    { name: 'ปฏิภาณ', phone: '086-XXXX-048', bank: 'kbank' },
    { name: 'อิสรีย์', phone: '094-XXXX-965', bank: 'scb' },
    { name: 'พุฒิพงศ์', phone: '092-XXXX-792', bank: 'sc' },
    { name: 'รัตนากร', phone: '082-XXXX-613', bank: 'scb' },
    { name: 'แพรวา', phone: '093-XXXX-457', bank: 'lh' },
    { name: 'สุพจน์', phone: '087-XXXX-349', bank: 'baac' },
    { name: 'จุฑามาศ', phone: '090-XXXX-622', bank: 'icbc' },
    { name: 'ชนาธิป', phone: '081-XXXX-514', bank: 'kk' },

    { name: 'นิชาภา', phone: '088-XXXX-286', bank: 'peer2pay' },
    { name: 'สมพงษ์', phone: '096-XXXX-033', bank: 'scb' },
    { name: 'พรรณราย', phone: '089-XXXX-740', bank: 'truewallet' },
    { name: 'ภานุวัฒน์', phone: '066-XXXX-846', bank: 'citi' },
    { name: 'ศิวพร', phone: '094-XXXX-277', bank: 'scb' },
    { name: 'ทรงพล', phone: '083-XXXX-852', bank: 'kbank' },
    { name: 'สุทธิดา', phone: '091-XXXX-368', bank: 'boc' },
    { name: 'มณีรัตน์', phone: '087-XXXX-797', bank: 'kbank' },
    { name: 'วริศร', phone: '090-XXXX-105', bank: 'scb' },
    { name: 'ทัศพงศ์', phone: '096-XXXX-674', bank: 'ktb' },

    { name: 'ณัฏฐนิชา', phone: '082-XXXX-498', bank: 'bbl' },
    { name: 'ณัฐชนน', phone: '093-XXXX-221', bank: 'bay' },
    { name: 'สิรภพ', phone: '089-XXXX-459', bank: 'ttb' },
    { name: 'นรีกานต์', phone: '097-XXXX-905', bank: 'uobt' },
] as const;

export const userRankData1 = [
    {
        rank: {
            name: "supreme",
            point: 789142
        },
        firstName: "สุพจน์"
    },
    {
        rank: {
            name: "supreme",
            point: 721456
        },
        firstName: "ธนกร"
    },
    {
        rank: {
            name: "supreme",
            point: 689234
        },
        firstName: "ชัยณรงค์"
    },
    {
        rank: {
            name: "supreme",
            point: 654321
        },
        firstName: "สุภาพร"
    },
    {
        rank: {
            name: "supreme",
            point: 612345
        },
        firstName: "ปิยะชาติ"
    },
    {
        rank: {
            name: "supreme",
            point: 598743
        },
        firstName: "พิมพ์ใจ"
    },
    {
        rank: {
            name: "supreme",
            point: 472167
        },
        firstName: "อารีรัตน์"
    },
    {
        rank: {
            name: "supreme",
            point: 328923
        },
        firstName: "สุดารัตน์"
    },
    {
        rank: {
            name: "supreme",
            point: 267892
        },
        firstName: "นิติพงษ์"
    },
    {
        rank: {
            name: "supreme",
            point: 190236
        },
        firstName: "นันทิดา"
    }
] as const;

// ... existing code ...

export const userRankData2 = [
    {
        rank: {
            name: "supreme",
            point: 695634
        },
        firstName: "วิภาวี"
    },
    {
        rank: {
            name: "supreme",
            point: 542891
        },
        firstName: "อนุชิต"
    },
    {
        rank: {
            name: "supreme",
            point: 538547
        },
        firstName: "สิริวรรณ"
    },
    {
        rank: {
            name: "supreme",
            point: 493278
        },
        firstName: "พิมพ์ชนก"
    },
    {
        rank: {
            name: "supreme",
            point: 449361
        },
        firstName: "มนัสวี"
    },
    {
        rank: {
            name: "supreme",
            point: 354792
        },
        firstName: "กิตติพงษ์"
    },
    {
        rank: {
            name: "supreme",
            point: 307156
        },
        firstName: "นิรมล"
    },
    {
        rank: {
            name: "supreme",
            point: 256823
        },
        firstName: "ปรีชา"
    },
    {
        rank: {
            name: "supreme",
            point: 223679
        },
        firstName: "วราภรณ์"
    },
    {
        rank: {
            name: "supreme",
            point: 211245
        },
        firstName: "สุรชัย"
    }
] as const;

export const userRankData3 = [
    {
        rank: {
            name: "supreme",
            point: 778924
        },
        firstName: "ธิดารัตน์"
    },
    {
        rank: {
            name: "supreme",
            point: 725638
        },
        firstName: "ภัทรพล"
    },
    {
        rank: {
            name: "supreme",
            point: 671492
        },
        firstName: "จริยา"
    },
    {
        rank: {
            name: "supreme",
            point: 618357
        },
        firstName: "วิชัย"
    },
    {
        rank: {
            name: "supreme",
            point: 565841
        },
        firstName: "นภาพร"
    },
    {
        rank: {
            name: "supreme",
            point: 512963
        },
        firstName: "กฤษณ์"
    },
    {
        rank: {
            name: "supreme",
            point: 469784
        },
        firstName: "รัชนี"
    },
    {
        rank: {
            name: "supreme",
            point: 426517
        },
        firstName: "ชัยวัฒน์"
    },
    {
        rank: {
            name: "supreme",
            point: 413892
        },
        firstName: "สุมิตรา"
    },
    {
        rank: {
            name: "supreme",
            point: 405163
        },
        firstName: "ธีระพงษ์"
    }
] as const;

export const userRankData4 = [
    {
        rank: {
            name: "supreme",
            point: 786543
        },
        firstName: "อรพิน"
    },
    {
        rank: {
            name: "supreme",
            point: 734296
        },
        firstName: "นพดล"
    },
    {
        rank: {
            name: "supreme",
            point: 681537
        },
        firstName: "ปทุมา"
    },
    {
        rank: {
            name: "supreme",
            point: 628419
        },
        firstName: "สมชาย"
    },
    {
        rank: {
            name: "supreme",
            point: 575832
        },
        firstName: "กัลยา"
    },
    {
        rank: {
            name: "supreme",
            point: 523647
        },
        firstName: "ธนภัทร"
    },
    {
        rank: {
            name: "supreme",
            point: 471958
        },
        firstName: "วิไลวรรณ"
    },
    {
        rank: {
            name: "supreme",
            point: 429673
        },
        firstName: "ประเวศ"
    },
    {
        rank: {
            name: "supreme",
            point: 417284
        },
        firstName: "สุภาณี"
    },
    {
        rank: {
            name: "supreme",
            point: 408935
        },
        firstName: "กิตติศักดิ์"
    }
] as const;

export const userRankData5 = [
    {
        rank: {
            name: "supreme",
            point: 792815
        },
        firstName: "ชลธิชา"
    },
    {
        rank: {
            name: "supreme",
            point: 747632
        },
        firstName: "อิทธิพล"
    },
    {
        rank: {
            name: "supreme",
            point: 694827
        },
        firstName: "พรทิพย์"
    },
    {
        rank: {
            name: "supreme",
            point: 641395
        },
        firstName: "สุรศักดิ์"
    },
    {
        rank: {
            name: "supreme",
            point: 588769
        },
        firstName: "นิตยา"
    },
    {
        rank: {
            name: "supreme",
            point: 535184
        },
        firstName: "ภาณุพงศ์"
    },
    {
        rank: {
            name: "supreme",
            point: 482573
        },
        firstName: "สุจิตรา"
    },
    {
        rank: {
            name: "supreme",
            point: 439618
        },
        firstName: "วีระพงษ์"
    },
    {
        rank: {
            name: "supreme",
            point: 421357
        },
        firstName: "อุบลวรรณ"
    },
    {
        rank: {
            name: "supreme",
            point: 404792
        },
        firstName: "สมพร"
    }
] as const;